import { useMemo } from "react";
import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import { NotificationStatus } from "@/types";
import { AllNotificationsDocument } from "./useNotificationsQuery.generated";
import { sortNotificationsByPriority } from "./notificationEnhancers";

gql`
	query AllNotifications($status: NotificationStatus) {
		account {
			id
			notifications(status: $status) {
				id
				status
				sortOrder
			}
			activeInvestingEntity {
				id
				notifications(status: $status) {
					id
					status
					sortOrder
					... on ConfirmUnsupportedCountryAccreditationNotification {
						country {
							id
							name
						}
					}
				}
			}
		}
	}
`;

type QueryOptions = {
	variables?: {
		status?: NotificationStatus;
	};
};

const useNotificationsQuery = (
	options: QueryOptions = {
		variables: {
			status: NotificationStatus.Incomplete,
		},
	},
) => {
	const queryResult = useQuery(AllNotificationsDocument, {
		...options,
	});

	const account = queryResult.data?.account;

	const notifications = useMemo(() => {
		// TODO: Remove this once APP-15833 is complete
		const blockList = [
			"VerifyIdentityNotification",
			"AddInvestingEntityNotification",
		];

		const accountNotifications = account?.notifications ?? [];
		const investingEntityNotifications =
			account?.activeInvestingEntity?.notifications ?? [];

		return sortNotificationsByPriority(
			[...accountNotifications, ...investingEntityNotifications].filter(
				({ __typename: typename }) => !blockList.includes(typename),
			),
		);
	}, [account]);

	return [notifications, queryResult];
};

export default useNotificationsQuery;
